<!-- One button per state: a `mat-icon` is only placed next to the label as a direct child of the button. -->
@if (isAdded()) {
  <button mat-flat-button type="button" disabled>
    <mat-icon>check</mat-icon>
    {{ 'page.artificialIntelligence.reportComment.added' | translate }}
  </button>
} @else if (isAdding()) {
  <button mat-flat-button type="button" disabled>
    <mat-progress-spinner mode="indeterminate" diameter="18" />
    {{ 'page.artificialIntelligence.reportComment.adding' | translate }}
  </button>
} @else {
  <button mat-flat-button type="button" (click)="onAdd()">
    <mat-icon>add_comment</mat-icon>
    {{ 'page.artificialIntelligence.reportComment.add' | translate }}
  </button>
}
